module.exports = __webpack_public_path__ + "img/thumb_16.f83c4027.jpg";